var map = {
	"./0.png": 122,
	"./1.png": 123,
	"./10.png": 124,
	"./100.png": 125,
	"./10001.png": 126,
	"./10002.png": 127,
	"./10003.png": 128,
	"./10004.png": 129,
	"./10005.png": 130,
	"./10006.png": 131,
	"./10007.png": 132,
	"./10008.png": 133,
	"./10009.png": 134,
	"./10010.png": 135,
	"./10011.png": 136,
	"./10012.png": 137,
	"./10013.png": 138,
	"./10014.png": 139,
	"./10015.png": 140,
	"./10016.png": 141,
	"./10017.png": 142,
	"./10018.png": 143,
	"./10019.png": 144,
	"./10020.png": 145,
	"./10021.png": 146,
	"./10022.png": 147,
	"./10023.png": 148,
	"./10024.png": 149,
	"./10025.png": 150,
	"./10026.png": 151,
	"./10027.png": 152,
	"./10028.png": 153,
	"./10029.png": 154,
	"./10030.png": 155,
	"./10031.png": 156,
	"./10032.png": 157,
	"./10033.png": 158,
	"./10034.png": 159,
	"./10035.png": 160,
	"./10036.png": 161,
	"./10037.png": 162,
	"./10038.png": 163,
	"./10039.png": 164,
	"./10040.png": 165,
	"./10041.png": 166,
	"./10042.png": 167,
	"./10043.png": 168,
	"./10044.png": 169,
	"./10045.png": 170,
	"./10046.png": 171,
	"./10047.png": 172,
	"./10048.png": 173,
	"./10049.png": 174,
	"./10050.png": 175,
	"./10051.png": 176,
	"./10052.png": 177,
	"./10053.png": 178,
	"./10054.png": 179,
	"./10055.png": 180,
	"./10056.png": 181,
	"./10057.png": 182,
	"./10058.png": 183,
	"./10059.png": 184,
	"./10060.png": 185,
	"./10061.png": 186,
	"./10062.png": 187,
	"./10063.png": 188,
	"./101.png": 189,
	"./102.png": 190,
	"./103.png": 191,
	"./104.png": 192,
	"./105.png": 193,
	"./106.png": 194,
	"./107.png": 195,
	"./108.png": 196,
	"./109.png": 197,
	"./11.png": 198,
	"./110.png": 199,
	"./111.png": 200,
	"./112.png": 201,
	"./113.png": 202,
	"./114.png": 203,
	"./115.png": 204,
	"./116.png": 205,
	"./117.png": 206,
	"./118.png": 207,
	"./119.png": 208,
	"./12.png": 209,
	"./120.png": 210,
	"./121.png": 211,
	"./122.png": 212,
	"./123.png": 213,
	"./124.png": 214,
	"./125.png": 215,
	"./126.png": 216,
	"./127.png": 217,
	"./128.png": 218,
	"./129.png": 219,
	"./13.png": 220,
	"./130.png": 221,
	"./131.png": 222,
	"./132.png": 223,
	"./133.png": 224,
	"./134.png": 225,
	"./135.png": 226,
	"./136.png": 227,
	"./137.png": 228,
	"./138.png": 229,
	"./139.png": 230,
	"./14.png": 231,
	"./140.png": 232,
	"./141.png": 233,
	"./142.png": 234,
	"./143.png": 235,
	"./144.png": 236,
	"./145.png": 237,
	"./146.png": 238,
	"./147.png": 239,
	"./148.png": 240,
	"./149.png": 241,
	"./15.png": 242,
	"./150.png": 243,
	"./151.png": 244,
	"./152.png": 245,
	"./153.png": 246,
	"./154.png": 247,
	"./155.png": 248,
	"./156.png": 249,
	"./157.png": 250,
	"./158.png": 251,
	"./159.png": 252,
	"./16.png": 253,
	"./160.png": 254,
	"./161.png": 255,
	"./162.png": 256,
	"./163.png": 257,
	"./164.png": 258,
	"./165.png": 259,
	"./166.png": 260,
	"./167.png": 261,
	"./168.png": 262,
	"./169.png": 263,
	"./17.png": 264,
	"./170.png": 265,
	"./171.png": 266,
	"./172.png": 267,
	"./173.png": 268,
	"./174.png": 269,
	"./175.png": 270,
	"./176.png": 271,
	"./177.png": 272,
	"./178.png": 273,
	"./179.png": 274,
	"./18.png": 275,
	"./180.png": 276,
	"./181.png": 277,
	"./182.png": 278,
	"./183.png": 279,
	"./184.png": 280,
	"./185.png": 281,
	"./186.png": 282,
	"./187.png": 283,
	"./188.png": 284,
	"./189.png": 285,
	"./19.png": 286,
	"./190.png": 287,
	"./191.png": 288,
	"./192.png": 289,
	"./193.png": 290,
	"./194.png": 291,
	"./195.png": 292,
	"./196.png": 293,
	"./197.png": 294,
	"./198.png": 295,
	"./199.png": 296,
	"./2.png": 75,
	"./20.png": 297,
	"./200.png": 298,
	"./201-a.png": 299,
	"./201-b.png": 300,
	"./201-c.png": 301,
	"./201-d.png": 302,
	"./201-e.png": 303,
	"./201-exclamation.png": 304,
	"./201-f.png": 305,
	"./201-g.png": 306,
	"./201-h.png": 307,
	"./201-i.png": 308,
	"./201-j.png": 309,
	"./201-k.png": 310,
	"./201-l.png": 311,
	"./201-m.png": 312,
	"./201-n.png": 313,
	"./201-o.png": 314,
	"./201-p.png": 315,
	"./201-q.png": 316,
	"./201-question.png": 317,
	"./201-r.png": 318,
	"./201-s.png": 319,
	"./201-t.png": 320,
	"./201-u.png": 321,
	"./201-v.png": 322,
	"./201-w.png": 323,
	"./201-x.png": 324,
	"./201-y.png": 325,
	"./201-z.png": 326,
	"./201.png": 327,
	"./202.png": 328,
	"./203.png": 329,
	"./204.png": 330,
	"./205.png": 331,
	"./206.png": 332,
	"./207.png": 333,
	"./208.png": 334,
	"./209.png": 335,
	"./21.png": 336,
	"./210.png": 337,
	"./211.png": 338,
	"./212.png": 339,
	"./213.png": 340,
	"./214.png": 341,
	"./215.png": 342,
	"./216.png": 343,
	"./217.png": 344,
	"./218.png": 345,
	"./219.png": 346,
	"./22.png": 347,
	"./220.png": 348,
	"./221.png": 349,
	"./222.png": 350,
	"./223.png": 351,
	"./224.png": 352,
	"./225.png": 353,
	"./226.png": 354,
	"./227.png": 355,
	"./228.png": 356,
	"./229.png": 357,
	"./23.png": 358,
	"./230.png": 359,
	"./231.png": 360,
	"./232.png": 361,
	"./233.png": 362,
	"./234.png": 363,
	"./235.png": 364,
	"./236.png": 365,
	"./237.png": 366,
	"./238.png": 367,
	"./239.png": 368,
	"./24.png": 369,
	"./240.png": 370,
	"./241.png": 371,
	"./242.png": 372,
	"./243.png": 373,
	"./244.png": 374,
	"./245.png": 375,
	"./246.png": 376,
	"./247.png": 377,
	"./248.png": 378,
	"./249.png": 379,
	"./25.png": 380,
	"./250.png": 381,
	"./251.png": 382,
	"./252.png": 383,
	"./253.png": 384,
	"./254.png": 385,
	"./255.png": 386,
	"./256.png": 387,
	"./257.png": 388,
	"./258.png": 389,
	"./259.png": 390,
	"./26.png": 391,
	"./260.png": 392,
	"./261.png": 393,
	"./262.png": 394,
	"./263.png": 395,
	"./264.png": 396,
	"./265.png": 397,
	"./266.png": 398,
	"./267.png": 399,
	"./268.png": 400,
	"./269.png": 401,
	"./27.png": 402,
	"./270.png": 403,
	"./271.png": 404,
	"./272.png": 405,
	"./273.png": 406,
	"./274.png": 407,
	"./275.png": 408,
	"./276.png": 409,
	"./277.png": 410,
	"./278.png": 411,
	"./279.png": 412,
	"./28.png": 413,
	"./280.png": 414,
	"./281.png": 415,
	"./282.png": 416,
	"./283.png": 417,
	"./284.png": 418,
	"./285.png": 419,
	"./286.png": 420,
	"./287.png": 421,
	"./288.png": 422,
	"./289.png": 423,
	"./29.png": 424,
	"./290.png": 425,
	"./291.png": 426,
	"./292.png": 427,
	"./293.png": 428,
	"./294.png": 429,
	"./295.png": 430,
	"./296.png": 431,
	"./297.png": 432,
	"./298.png": 433,
	"./299.png": 434,
	"./3.png": 435,
	"./30.png": 436,
	"./300.png": 437,
	"./301.png": 438,
	"./302.png": 439,
	"./303.png": 440,
	"./304.png": 441,
	"./305.png": 442,
	"./306.png": 443,
	"./307.png": 444,
	"./308.png": 445,
	"./309.png": 446,
	"./31.png": 447,
	"./310.png": 448,
	"./311.png": 449,
	"./312.png": 450,
	"./313.png": 451,
	"./314.png": 452,
	"./315.png": 453,
	"./316.png": 454,
	"./317.png": 455,
	"./318.png": 456,
	"./319.png": 457,
	"./32.png": 458,
	"./320.png": 459,
	"./321.png": 460,
	"./322.png": 461,
	"./323.png": 462,
	"./324.png": 463,
	"./325.png": 464,
	"./326.png": 465,
	"./327.png": 466,
	"./328.png": 467,
	"./329.png": 468,
	"./33.png": 469,
	"./330.png": 470,
	"./331.png": 471,
	"./332.png": 472,
	"./333.png": 473,
	"./334.png": 474,
	"./335.png": 475,
	"./336.png": 476,
	"./337.png": 477,
	"./338.png": 478,
	"./339.png": 479,
	"./34.png": 480,
	"./340.png": 481,
	"./341.png": 482,
	"./342.png": 483,
	"./343.png": 484,
	"./344.png": 485,
	"./345.png": 486,
	"./346.png": 487,
	"./347.png": 488,
	"./348.png": 489,
	"./349.png": 490,
	"./35.png": 491,
	"./350.png": 492,
	"./351-rainy.png": 493,
	"./351-snowy.png": 494,
	"./351-sunny.png": 495,
	"./351.png": 496,
	"./352.png": 497,
	"./353.png": 498,
	"./354.png": 499,
	"./355.png": 500,
	"./356.png": 501,
	"./357.png": 502,
	"./358.png": 503,
	"./359.png": 504,
	"./36.png": 505,
	"./360.png": 506,
	"./361.png": 507,
	"./362.png": 508,
	"./363.png": 509,
	"./364.png": 510,
	"./365.png": 511,
	"./366.png": 512,
	"./367.png": 513,
	"./368.png": 514,
	"./369.png": 515,
	"./37.png": 516,
	"./370.png": 517,
	"./371.png": 518,
	"./372.png": 519,
	"./373.png": 520,
	"./374.png": 521,
	"./375.png": 522,
	"./376.png": 523,
	"./377.png": 524,
	"./378.png": 525,
	"./379.png": 526,
	"./38.png": 527,
	"./380.png": 528,
	"./381.png": 529,
	"./382.png": 530,
	"./383.png": 531,
	"./384.png": 532,
	"./385.png": 533,
	"./386-attack.png": 534,
	"./386-defense.png": 535,
	"./386-normal.png": 536,
	"./386-speed.png": 537,
	"./386.png": 538,
	"./387.png": 539,
	"./388.png": 540,
	"./389.png": 541,
	"./39.png": 542,
	"./390.png": 543,
	"./391.png": 544,
	"./392.png": 545,
	"./393.png": 546,
	"./394.png": 547,
	"./395.png": 548,
	"./396.png": 549,
	"./397.png": 550,
	"./398.png": 551,
	"./399.png": 552,
	"./4.png": 553,
	"./40.png": 554,
	"./400.png": 555,
	"./401.png": 556,
	"./402.png": 557,
	"./403.png": 558,
	"./404.png": 559,
	"./405.png": 560,
	"./406.png": 561,
	"./407.png": 562,
	"./408.png": 563,
	"./409.png": 564,
	"./41.png": 565,
	"./410.png": 566,
	"./411.png": 567,
	"./412-plant.png": 568,
	"./412-sandy.png": 569,
	"./412-trash.png": 570,
	"./412.png": 571,
	"./413-plant.png": 572,
	"./413-sandy.png": 573,
	"./413-trash.png": 574,
	"./413.png": 575,
	"./414.png": 576,
	"./415.png": 577,
	"./416.png": 578,
	"./417.png": 579,
	"./418.png": 580,
	"./419.png": 581,
	"./42.png": 582,
	"./420.png": 583,
	"./421-overcast.png": 584,
	"./421-sunshine.png": 585,
	"./421.png": 586,
	"./422-east.png": 587,
	"./422-west.png": 588,
	"./422.png": 589,
	"./423-east.png": 590,
	"./423-west.png": 591,
	"./423.png": 592,
	"./424.png": 593,
	"./425.png": 594,
	"./426.png": 595,
	"./427.png": 596,
	"./428.png": 597,
	"./429.png": 598,
	"./43.png": 599,
	"./430.png": 600,
	"./431.png": 601,
	"./432.png": 602,
	"./433.png": 603,
	"./434.png": 604,
	"./435.png": 605,
	"./436.png": 606,
	"./437.png": 607,
	"./438.png": 608,
	"./439.png": 609,
	"./44.png": 610,
	"./440.png": 611,
	"./441.png": 612,
	"./442.png": 613,
	"./443.png": 614,
	"./444.png": 615,
	"./445.png": 616,
	"./446.png": 617,
	"./447.png": 618,
	"./448.png": 619,
	"./449.png": 620,
	"./45.png": 621,
	"./450.png": 622,
	"./451.png": 623,
	"./452.png": 624,
	"./453.png": 625,
	"./454.png": 626,
	"./455.png": 627,
	"./456.png": 628,
	"./457.png": 629,
	"./458.png": 630,
	"./459.png": 631,
	"./46.png": 632,
	"./460.png": 633,
	"./461.png": 634,
	"./462.png": 635,
	"./463.png": 636,
	"./464.png": 637,
	"./465.png": 638,
	"./466.png": 639,
	"./467.png": 640,
	"./468.png": 641,
	"./469.png": 642,
	"./47.png": 643,
	"./470.png": 644,
	"./471.png": 645,
	"./472.png": 646,
	"./473.png": 647,
	"./474.png": 648,
	"./475.png": 649,
	"./476.png": 650,
	"./477.png": 651,
	"./478.png": 652,
	"./479-fan.png": 653,
	"./479-frost.png": 654,
	"./479-heat.png": 655,
	"./479-mow.png": 656,
	"./479-wash.png": 657,
	"./479.png": 658,
	"./48.png": 659,
	"./480.png": 660,
	"./481.png": 661,
	"./482.png": 662,
	"./483.png": 663,
	"./484.png": 664,
	"./485.png": 665,
	"./486.png": 666,
	"./487-altered.png": 667,
	"./487-origin.png": 668,
	"./487.png": 669,
	"./488.png": 670,
	"./489.png": 671,
	"./49.png": 672,
	"./490.png": 673,
	"./491.png": 674,
	"./492-land.png": 675,
	"./492-sky.png": 676,
	"./492.png": 677,
	"./493-bug.png": 678,
	"./493-dark.png": 679,
	"./493-dragon.png": 680,
	"./493-electric.png": 681,
	"./493-fairy.png": 682,
	"./493-fighting.png": 683,
	"./493-fire.png": 684,
	"./493-flying.png": 685,
	"./493-ghost.png": 686,
	"./493-grass.png": 687,
	"./493-ground.png": 688,
	"./493-ice.png": 689,
	"./493-normal.png": 690,
	"./493-poison.png": 691,
	"./493-psychic.png": 692,
	"./493-rock.png": 693,
	"./493-steel.png": 694,
	"./493-unknown.png": 695,
	"./493-water.png": 696,
	"./493.png": 697,
	"./494.png": 698,
	"./495.png": 699,
	"./496.png": 700,
	"./497.png": 701,
	"./498.png": 702,
	"./499.png": 703,
	"./5.png": 704,
	"./50.png": 705,
	"./500.png": 706,
	"./501.png": 707,
	"./502.png": 708,
	"./503.png": 709,
	"./504.png": 710,
	"./505.png": 711,
	"./506.png": 712,
	"./507.png": 713,
	"./508.png": 714,
	"./509.png": 715,
	"./51.png": 716,
	"./510.png": 717,
	"./511.png": 718,
	"./512.png": 719,
	"./513.png": 720,
	"./514.png": 721,
	"./515.png": 722,
	"./516.png": 723,
	"./517.png": 724,
	"./518.png": 725,
	"./519.png": 726,
	"./52.png": 727,
	"./520.png": 728,
	"./521.png": 729,
	"./522.png": 730,
	"./523.png": 731,
	"./524.png": 732,
	"./525.png": 733,
	"./526.png": 734,
	"./527.png": 735,
	"./528.png": 736,
	"./529.png": 737,
	"./53.png": 738,
	"./530.png": 739,
	"./531.png": 740,
	"./532.png": 741,
	"./533.png": 742,
	"./534.png": 743,
	"./535.png": 744,
	"./536.png": 745,
	"./537.png": 746,
	"./538.png": 747,
	"./539.png": 748,
	"./54.png": 749,
	"./540.png": 750,
	"./541.png": 751,
	"./542.png": 752,
	"./543.png": 753,
	"./544.png": 754,
	"./545.png": 755,
	"./546.png": 756,
	"./547.png": 757,
	"./548.png": 758,
	"./549.png": 759,
	"./55.png": 760,
	"./550-blue-striped.png": 761,
	"./550-red-striped.png": 762,
	"./550.png": 763,
	"./551.png": 764,
	"./552.png": 765,
	"./553.png": 766,
	"./554.png": 767,
	"./555-standard.png": 768,
	"./555-zen.png": 769,
	"./555.png": 770,
	"./556.png": 771,
	"./557.png": 772,
	"./558.png": 773,
	"./559.png": 774,
	"./56.png": 775,
	"./560.png": 776,
	"./561.png": 777,
	"./562.png": 778,
	"./563.png": 779,
	"./564.png": 780,
	"./565.png": 781,
	"./566.png": 782,
	"./567.png": 783,
	"./568.png": 784,
	"./569.png": 785,
	"./57.png": 786,
	"./570.png": 787,
	"./571.png": 788,
	"./572.png": 789,
	"./573.png": 790,
	"./574.png": 791,
	"./575.png": 792,
	"./576.png": 793,
	"./577.png": 794,
	"./578.png": 795,
	"./579.png": 796,
	"./58.png": 797,
	"./580.png": 798,
	"./581.png": 799,
	"./582.png": 800,
	"./583.png": 801,
	"./584.png": 802,
	"./585-autumn.png": 803,
	"./585-spring.png": 804,
	"./585-summer.png": 805,
	"./585-winter.png": 806,
	"./585.png": 807,
	"./586-autumn.png": 808,
	"./586-spring.png": 809,
	"./586-summer.png": 810,
	"./586-winter.png": 811,
	"./586.png": 812,
	"./587.png": 813,
	"./588.png": 814,
	"./589.png": 815,
	"./59.png": 816,
	"./590.png": 817,
	"./591.png": 818,
	"./592.png": 819,
	"./593.png": 820,
	"./594.png": 821,
	"./595.png": 822,
	"./596.png": 823,
	"./597.png": 824,
	"./598.png": 825,
	"./599.png": 826,
	"./6.png": 827,
	"./60.png": 828,
	"./600.png": 829,
	"./601.png": 830,
	"./602.png": 831,
	"./603.png": 832,
	"./604.png": 833,
	"./605.png": 834,
	"./606.png": 835,
	"./607.png": 836,
	"./608.png": 837,
	"./609.png": 838,
	"./61.png": 839,
	"./610.png": 840,
	"./611.png": 841,
	"./612.png": 842,
	"./613.png": 843,
	"./614.png": 844,
	"./615.png": 845,
	"./616.png": 846,
	"./617.png": 847,
	"./618.png": 848,
	"./619.png": 849,
	"./62.png": 850,
	"./620.png": 851,
	"./621.png": 852,
	"./622.png": 853,
	"./623.png": 854,
	"./624.png": 855,
	"./625.png": 856,
	"./626.png": 857,
	"./627.png": 858,
	"./628.png": 859,
	"./629.png": 860,
	"./63.png": 861,
	"./630.png": 862,
	"./631.png": 863,
	"./632.png": 864,
	"./633.png": 865,
	"./634.png": 866,
	"./635.png": 867,
	"./636.png": 868,
	"./637.png": 869,
	"./638.png": 870,
	"./639.png": 871,
	"./64.png": 872,
	"./640.png": 873,
	"./641-incarnate.png": 874,
	"./641-therian.png": 875,
	"./641.png": 876,
	"./642-incarnate.png": 877,
	"./642-therian.png": 878,
	"./642.png": 879,
	"./643.png": 880,
	"./644.png": 881,
	"./645-incarnate.png": 882,
	"./645-therian.png": 883,
	"./645.png": 884,
	"./646-black.png": 885,
	"./646-white.png": 886,
	"./646.png": 887,
	"./647-ordinary.png": 888,
	"./647-resolute.png": 889,
	"./647.png": 890,
	"./648-aria.png": 891,
	"./648-pirouette.png": 892,
	"./648.png": 893,
	"./649-burn.png": 894,
	"./649-chill.png": 895,
	"./649-douse.png": 896,
	"./649-shock.png": 897,
	"./649.png": 898,
	"./65.png": 899,
	"./650.png": 900,
	"./651.png": 901,
	"./652.png": 902,
	"./653.png": 903,
	"./654.png": 904,
	"./655.png": 905,
	"./656.png": 906,
	"./657.png": 907,
	"./658.png": 908,
	"./659.png": 909,
	"./66.png": 910,
	"./660.png": 911,
	"./661.png": 912,
	"./662.png": 913,
	"./663.png": 914,
	"./664.png": 915,
	"./665.png": 916,
	"./666-meadow.png": 917,
	"./666.png": 918,
	"./667.png": 919,
	"./668.png": 920,
	"./669-red.png": 921,
	"./669.png": 922,
	"./67.png": 923,
	"./670-eternal.png": 924,
	"./670-red.png": 925,
	"./670.png": 926,
	"./671-red.png": 927,
	"./671.png": 928,
	"./672.png": 929,
	"./673.png": 930,
	"./674.png": 931,
	"./675.png": 932,
	"./676-natural.png": 933,
	"./676.png": 934,
	"./677.png": 935,
	"./678-male.png": 936,
	"./678.png": 937,
	"./679.png": 938,
	"./68.png": 939,
	"./680.png": 940,
	"./681-blade.png": 941,
	"./681-shield.png": 942,
	"./681.png": 943,
	"./682.png": 944,
	"./683.png": 945,
	"./684.png": 946,
	"./685.png": 947,
	"./686.png": 948,
	"./687.png": 949,
	"./688.png": 950,
	"./689.png": 951,
	"./69.png": 952,
	"./690.png": 953,
	"./691.png": 954,
	"./692.png": 955,
	"./693.png": 956,
	"./694.png": 957,
	"./695.png": 958,
	"./696.png": 959,
	"./697.png": 960,
	"./698.png": 961,
	"./699.png": 962,
	"./7.png": 963,
	"./70.png": 964,
	"./700.png": 965,
	"./701.png": 966,
	"./702.png": 967,
	"./703.png": 968,
	"./704.png": 969,
	"./705.png": 970,
	"./706.png": 971,
	"./707.png": 972,
	"./708.png": 973,
	"./709.png": 974,
	"./71.png": 975,
	"./710-average.png": 976,
	"./710.png": 977,
	"./711-average.png": 978,
	"./711.png": 979,
	"./712.png": 980,
	"./713.png": 981,
	"./714.png": 982,
	"./715.png": 983,
	"./716-active.png": 984,
	"./716.png": 985,
	"./717.png": 986,
	"./718.png": 987,
	"./719.png": 988,
	"./72.png": 989,
	"./720.png": 990,
	"./721.png": 991,
	"./73.png": 992,
	"./74.png": 993,
	"./75.png": 994,
	"./76.png": 995,
	"./77.png": 996,
	"./78.png": 997,
	"./79.png": 998,
	"./8.png": 999,
	"./80.png": 1000,
	"./81.png": 1001,
	"./82.png": 1002,
	"./83.png": 1003,
	"./84.png": 1004,
	"./85.png": 1005,
	"./86.png": 1006,
	"./87.png": 1007,
	"./88.png": 1008,
	"./89.png": 1009,
	"./9.png": 1010,
	"./90.png": 1011,
	"./91.png": 1012,
	"./92.png": 1013,
	"./93.png": 1014,
	"./94.png": 1015,
	"./95.png": 1016,
	"./96.png": 1017,
	"./97.png": 1018,
	"./98.png": 1019,
	"./99.png": 1020,
	"./egg-manaphy.png": 1021,
	"./egg.png": 1022,
	"./substitute.png": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;